window.addEventListener('message', function messageHandler(e) {
  if (e.data === 'aoflReady') {
    require('./home-page/home-page.html');
    window.removeEventListener('message', messageHandler);
  }
});



// WEBPACK FOOTER //
// ./home/en-US/js/main.js